import { jsxs as t, jsx as e } from "react/jsx-runtime";
import { Text as r } from "../../atoms/Text/Text.mjs";
import { Icon as o } from "../../atoms/Icon/Icon.mjs";
import { cn as s } from "../../../utils/utils.mjs";
function f({ previewUrl: a, fileName: i, onRemove: l, className: c }) {
  return /* @__PURE__ */ t("div", { className: s("size-full flex gap-3 justify-center items-center text-black dark:text-white", c), children: [
    /* @__PURE__ */ e("img", { src: a, alt: "Uploaded image", className: "object-cover w-12 h-12 rounded-sm shrink-0" }),
    /* @__PURE__ */ t("div", { className: "flex flex-col overflow-hidden", children: [
      /* @__PURE__ */ e(r, { fontSize: "sm", className: "truncate", children: i }),
      /* @__PURE__ */ e(r, { fontWeight: "regular", fontSize: "xs", className: "text-black dark:text-neutral-dark-600", children: "Selected image" })
    ] }),
    /* @__PURE__ */ e("button", { type: "button", onClick: l, "aria-label": "Remove image", title: "Remove image", children: /* @__PURE__ */ e(
      o,
      {
        name: "close",
        width: 16,
        height: 16,
        className: "[&_path]:fill-black dark:[&_path]:fill-white hover:cursor-pointer"
      }
    ) })
  ] });
}
export {
  f as SuccessState
};
